// extracted by mini-css-extract-plugin
export default {"root":"ChoicePlan_root__rQim-","item":"ChoicePlan_item__uOqOb","content":"ChoicePlan_content__6bp-Z","aside":"ChoicePlan_aside__kgEx-"};